import { notification } from "antd";
import { fetchPaymentBankInit } from "./topupService";

export const triggerMiniAppPayment = async (orderCode, amount) => {
  if (!orderCode) {
    notification.error({
      message: "Thanh toán thất bại",
      description: "Đã xảy ra lỗi khi thanh toán",
    });
    return null;
  };

  try {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.NativeJavascriptInterface
    ) {
      // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
      window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
        orderCode: orderCode,
      });
    } else {
      console.error(
        "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
      );
    }
    // Send orderCode for Android
    if (window.webkit !== undefined) {
      if (window.webkit.messageHandlers.appInterface !== undefined) {
        window.webkit.messageHandlers.appInterface.postMessage(
          JSON.stringify({
            orderCode: orderCode,
          })
        );
      }
    }
    if (window.appInterface !== undefined) {
      window.appInterface.postMessage(
        JSON.stringify({
          orderCode: orderCode,
        })
      );
    }


  } catch (error) {
    console.error("triggerMiniAppPayment error:", error.response?.data?.err);
    notification.error({
      message: "Thanh toán thất bại",
      description: error.response?.data?.err || "Đã xảy ra lỗi khi thanh toán",
    });
  }
};
